import 'picturefill';

export default () => {
  // Picture element HTML5 shiv
    document.createElement( "picture" );
};


/** WEBPACK FOOTER **
 ** ./assets/src/js/pictureFill/pictureFill.js
 **/